/*
 * @Author: Long
 * @Date: 2021-05-05 15:08:23
 * @LastEditors: Long
 * @LastEditTime: 2022-03-08 21:00:29
 */
const service = require('@/assets/js/request')
const env = process.env

class left {
  /**
   * 获取列表数据
   */
  static getColumnId (target) {
    service.request({
      method: 'POST',
      url: 'getColumnId',
      params: {
        id: target.id
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            var item = res.data[i]
            if (item.cover_img !== '') {
              item.cover_img = env.IMG_URL + item.cover_img
            }
            if (item.id === target.cate_id) {
              target.con = res.data[i]
            }
          }
        }
        target.navlist = res.data
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default left



// WEBPACK FOOTER //
// ./src/components/services/left/left.js